export const LegalTransactionRelationshipTypeEnum = {
  PurchaseContract: 1,
  Inheritance: 2,
  Mortgage: 3,
  Company: 4,
  Marriage: 5,
  Family: 6,
  SignatureCertification: 8,
  LandRegisterQuery: 9,
  Testament: 10,
  InheritanceProvision: 11,
  General: 12,
} as const;

export type LegalTransactionRelationshipTypeEnum =
  (typeof LegalTransactionRelationshipTypeEnum)[keyof typeof LegalTransactionRelationshipTypeEnum];
